/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-06-25 15:32:18
 * @FilePath: /91qs_answer_frontpro/src/components/QTitle/QTitle.js
 */
import React, { useEffect, useLayoutEffect, useContext } from "react";
import styles from "./QTitle.module.less";
import { isMobile } from "@/utils/common";
import { contexData } from "@/store";
import TextCheckbox from "@/pages/checkbox/TextCheckbox";
import TextRadio from "@/pages/radio/TextRadio";

const QTitle = (props) => {
  const { info, showImageViewer, themeId, isMinimalTheme } = props;
  const { model, code, description } = info;
  const { infoContex } = useContext(contexData); //解构得到属性
  const resolvedThemeId = themeId ?? infoContex?.themeId;
  const minimalTheme = Number(resolvedThemeId) === 4 || !!isMinimalTheme;
  // console.log("infoContex", infoContex);
  const IsPC = () => {
    var userAgentInfo = navigator.userAgent;
    var Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod",
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  };
  useEffect(() => {
    if (!IsPC()) {
      // 动态修改 img宽度
      try {
        const dom = document.getElementsByTagName("img");

        for (let element1 of dom) {
          element1.style.maxWidth = "100%";
          element1.style.marginBottom = "5px";
        }
      } catch (error) {
        console.error(error);
      }
    }
    try {
      let viedos = Array.from(document.getElementsByTagName("video"));
      if (viedos && viedos.length > 0) {
        viedos.forEach((element, index) => {
          element.play().catch((error) => {
            // 当播放异常时，走异常流程
            console.error("浏览器不支持这样做");
          });
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useLayoutEffect(() => {
    if (showImageViewer) {
      var viewer = new window.Viewer(document.getElementById("root"));
      return () => {
        viewer.destroy();
      };
    }
  });

  useLayoutEffect(() => {
    if ((description || "").includes("<pre><code>")) {
      const partten = /<pre><code>(.*?)<\/code><\/pre>/;
      const found = description.match(partten);
      const str = found?.[1] || "{}";
      const obj = JSON.parse(str.replace(/&quot;/g, '"'));
      try {
        const elements = document.getElementsByTagName("video");
        for (const [index, width] of Object.entries(obj)) {
          elements[index].style.width = width + "px";
        }
      } catch {}
    }
  });

    useEffect(() => {
        if ((description || "").includes("<pre><code>")) {
      const partten = /<pre><code>(.*?)<\/code><\/pre>/;
      const found = description.match(partten);
      const str = found?.[1] || "{}";
      const obj = JSON.parse(str.replace(/&quot;/g, '"'));
      try {
        const elements = document.getElementsByTagName("video");
        for (const [index, width] of Object.entries(obj)) {
          elements[index].style.width = width + "px";
        }
      } catch {}
    }
     }, [ ])


  const html = (description || "【普通单选题】")
    .replace(/undefined/g, "其他")
    .replace(/<pre>.*?<\/pre>/, "")
    .replace(/<p><\/p>/g, "<br />")
    .replace(/\n\n/g, "<br />")
    .replace(/\s{2}/g, "&nbsp;&nbsp;")
    .replace(/<video /g,`<video  controlslist="nodownload nofullscreen noremoteplayback noplaybackrate "    disablePictureInPicture  `)

    ;



  const [_, s] = document.location.href.split("/91");
   return (
    <div
      className="q-title"
      style={{
        color: infoContex.preferences?.stemColour,
        lineHeight: "1.4em",
        ...(minimalTheme &&
          // (model === "base_radio" || model === "base_checkbox") &&
            {
            marginBottom: 0,
            paddingBottom:26,
          }),
      }}
    >
      {/* {html} */}
      {(infoContex.preferences?.codeType === null ||
        infoContex.preferences?.codeType === 0) &&
        info.model !== "explain" && (
          <div
            className="q-title-code"
            style={{ backgroundColor: infoContex.preferences?.questionCodeColour }}
          >
            {code || ""}
          </div>
        )}

      {(infoContex.preferences?.codeType === 1 && info.model !== "explain" )&& (
        <div
          className="q-title-code"
          style={{ backgroundColor: infoContex.preferences?.questionCodeColour }}
        >
          {(s || "accdefghijklmn").length > 10 ? code : info.questionNo || ""}
        </div>
      )}


      {model === "text_radio" ? (
        <TextRadio {...props} />
      ) : model === "text_checkbox" ? (
        <TextCheckbox {...props} />
      ) : (
        <div
          className={`${styles.q_title_text} ${isMobile ? styles.mobile : ""}`}
          style={{
            width: "100%",
            wordBreak: "break-all",
            marginTop: 4, // 线上对齐
          }}
          dangerouslySetInnerHTML={{
            __html: html,
          }}
        />
      )}
      {/* {html} */}
    </div>
  );
};

export default QTitle;
